/* Mobile-optimized JavaScript for Clarity Conscious Theme */

document.addEventListener('DOMContentLoaded', function() {
  // Lazy loading for images
  const lazyImages = document.querySelectorAll('img:not(.loaded)');
  
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          lazyImage.classList.add('loaded');
          imageObserver.unobserve(lazyImage);
        }
      });
    });

    lazyImages.forEach(function(lazyImage) {
      // Add lazy-load class for styling
      lazyImage.classList.add('lazy-load');
      
      // Store original src
      if (!lazyImage.dataset.src) {
        lazyImage.dataset.src = lazyImage.src;
      }
      
      imageObserver.observe(lazyImage);
    });
  } else {
    // Fallback for browsers that don't support IntersectionObserver
    let active = false;

    const lazyLoad = function() {
      if (active === false) {
        active = true;

        setTimeout(function() {
          lazyImages.forEach(function(lazyImage) {
            if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
              lazyImage.src = lazyImage.dataset.src;
              lazyImage.classList.add('loaded');
              
              lazyImages = lazyImages.filter(function(image) {
                return image !== lazyImage;
              });

              if (lazyImages.length === 0) {
                document.removeEventListener("scroll", lazyLoad);
                window.removeEventListener("resize", lazyLoad);
                window.removeEventListener("orientationchange", lazyLoad);
              }
            }
          });

          active = false;
        }, 200);
      }
    };

    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("orientationchange", lazyLoad);
    lazyLoad();
  }
  
  // Mobile-friendly touch events for sliders
  const sliders = document.querySelectorAll('.slider-wrapper-clarity');
  
  sliders.forEach(function(slider) {
    let startX, moveX, initialPosition;
    let isDown = false;
    
    // Touch events
    slider.addEventListener('touchstart', function(e) {
      isDown = true;
      slider.classList.add('active');
      startX = e.touches[0].pageX;
      initialPosition = slider.scrollLeft;
    });
    
    slider.addEventListener('touchend', function() {
      isDown = false;
      slider.classList.remove('active');
    });
    
    slider.addEventListener('touchmove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      moveX = e.touches[0].pageX;
      const walk = (moveX - startX) * 2; // Scroll speed multiplier
      slider.scrollLeft = initialPosition - walk;
    });
  });
  
  // Optimize animations on mobile
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  
  if (isMobile) {
    // Reduce animation complexity on mobile
    const animatedElements = document.querySelectorAll('.hero-title, .hero-subtitle, .cycling-text, .hero-highlight-text, .hero-button');
    
    animatedElements.forEach(function(element) {
      element.style.animationDuration = '0.5s';
    });
  }
  
  // Add touch-friendly class to body for CSS targeting
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
    document.body.classList.add('touch-device');
  }
  
  // Improve header for mobile
  const header = document.querySelector('header[role="banner"]');
  const headerImage = header.querySelector('img');
  
  if (headerImage && isMobile) {
    headerImage.setAttribute('width', '150');
    headerImage.setAttribute('height', '125');
  }
});
